import React, { useState, useEffect } from 'react';
import './App.css';
import Footer from './Components/Footer';
import CartSection from './Components/CartSection';
import CartBox from './Components/CartBox';
import { SnackbarProvider, enqueueSnackbar } from 'notistack';
import { CartProvider } from './CartContext';
import { SearchProvider } from './SearchContext';
import Orders from './Components/Orders';
import Home from './pages/Home';
import Product from './pages/Product';
import { Routes, Route, useLocation } from 'react-router-dom';
import 'bootstrap-icons/font/bootstrap-icons.css';
import PopupInfo from './Components/PopupInfo';
import Login from "./Components/login"; 
import OrderDetail from "./Components/OrderDetail";
import ProductDetail from "./pages/Product/productDetail";
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';


function App() {
  const [cart, setCart] = useState(() => {
  // Try to load from sessionStorage first
  const storedCart = localStorage.getItem("cartValue");
  return storedCart ? JSON.parse(storedCart) : [];
});
  const [cartVisible, setCartVisible] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState('');
  const [pageVisible, setPageVisible] = useState(false);
  const [ordersVisible, SetOrdersVisible] = useState(false);
  const [loggedIn, setLoggedIn] = useState(false);
  const [showPopup, setShowPopup] = useState(true);
  const [showPlacedOrderSummary, setShowPlacedOrderSummary] = useState(false);

  const [form, setForm] = useState({
    name: '',
    phoneNumber: '',
    email: '',
    address: '',
    tableNo: '',
  });

  const location = useLocation(); // detect current route
  useEffect(() => {
  localStorage.setItem("cartValue", JSON.stringify(cart));
}, [cart]);

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const tableNo = queryParams.get('table');
    if (tableNo) {
      setForm((prev) => ({ ...prev, tableNo }));
      setShowPopup(true);
      setPageVisible(true);
    } else {
      setShowPopup(false);
      setPageVisible(false);
    }
  }, [location]);

  const handleClick = (menuItem) => {
    const isDuplicate = cart.some((item) =>
      item._id === menuItem._id && item.name === menuItem.name
    );
    if (!isDuplicate) {
      setCart([...cart, menuItem]);
      localStorage.setItem("cartValue", JSON.stringify([...cart, menuItem]));
    } else {
      enqueueSnackbar('Item already Added', { variant: 'error' });
    }
  };

  const handleCartClick = () => {
    setCartVisible(!cartVisible);
  };

  // Hide navbar & footer on login page
  const hideLayout =
    location.pathname === "/login" ||
    location.pathname === "/orders/orderview";


  return (
    <SnackbarProvider>
      <CartProvider>
        <SearchProvider>
          <>
            {!hideLayout && (
              <CartSection
                size={cart.length}
                handleCartClick={handleCartClick}
                phoneNumber={phoneNumber}
                setloggedIn={setLoggedIn}
                setPhoneNumber={setPhoneNumber}
                pageVisible={pageVisible}
                setCartVisible={setCartVisible}
                setPageVisible={setPageVisible}
                form={form}
                setForm={setForm}
                loggedIn={loggedIn}
                setLoggedIn={setLoggedIn}
                SetOrdersVisible={SetOrdersVisible}
                setShowPlacedOrderSummary={setShowPlacedOrderSummary}
              />
            )}

            {ordersVisible && !hideLayout && (
              <Orders SetOrdersVisible={SetOrdersVisible} setPageVisible={setPageVisible} />
            )}

            {!ordersVisible && (
              <>
                {!hideLayout && (
                  <CartBox
                    cart={cart}
                    setCart={setCart}
                    size={cart.length}
                    cartVisible={cartVisible}
                    setCartVisible={setCartVisible}
                    handleCartClick={handleCartClick}
                    phoneNumber={phoneNumber}
                    setPageVisible={setPageVisible}
                    pageVisible={pageVisible}
                    form={form}
                    setForm={setForm}
                    loggedIn={loggedIn}
                  />
                )}

                <Routes>
                  <Route
                    path="/"
                    element={
                      <>
                        {showPopup && <PopupInfo setShowPopup={setShowPopup} />}
                        <Home
                          handleClick={handleClick}
                          handleCartClick={handleCartClick}
                          cart={cart}
                          pageVisible={pageVisible}
                        />
                      </>
                    }
                  />
                  <Route
                    path="/products/:id"
                    element={
                      <Product
                        handleClick={handleClick}
                        handleCartClick={handleCartClick}
                        cart={cart}
                        setCart={setCart}
                        setCartVisible={setCartVisible}
                      />
                    }
                  />
                  <Route path="/login" element={<Login />} />
<Route path="/orders/orderview" element={<OrderDetail />} />
<Route
  path="/product/:id"
  element={
    <ProductDetail
      handleClick={handleClick}
      cart={cart}
      setCart={setCart}
    />
  }
/>


                </Routes>

                {!hideLayout && <Footer size={cart.length} setCartVisible={setCartVisible} />}
              </>
            )}
          </>
        </SearchProvider>
      </CartProvider>
    </SnackbarProvider>
  );
}

export default App;